// extracted by mini-css-extract-plugin
export default {"layer":"BackgroundLayer_layer__iwQ7A","media":"BackgroundLayer_media__FjYv-","vignette":"BackgroundLayer_vignette__voen9"};